import { createAction, props } from '@ngrx/store';

export const routeUrl = createAction('[Route Guard URL] Store Guarded URL', props<{ routeUrl: string | null }>());
